import React from 'react'

export const LightBgButton = ({ label, bg = 'var(--primary-color)', color = '#fff', click = null }) => {
    return (
        <button
            style={{
                width: 'auto',
                height: 'auto',
                padding: '10px 20px',
                gap: '10px',
                fontSize: '0.8rem',
                marginBottom: '1.2rem',
                fontFamily: 'inter',
                color,
                border: 'none',
                borderRadius: '50px',
                backgroundColor: bg,
            }}> {label}</button >
    )
}
